module.exports = __webpack_public_path__ + "static/media/logo.d23032f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/include/logo.png
// module id = 204
// module chunks = 0